export default "/images/3fa0e60c60582a5bd1a70f49fc5de56f.avif";